export class LayoutNames {
    public static readonly UserLayout = "user-layout";
    public static readonly UnauthorizedLayout = "unauthorized-layout";
}
